import { LiveNewsContentEntity, } from "@domains/entities/interfaces/iLiveNews";
var LiveNewsDataMapper = /** @class */ (function () {
    function LiveNewsDataMapper() {
    }
    LiveNewsDataMapper.prototype.mapTo = function (liveNewsData) {
        var entity = new Array();
        liveNewsData.map(function (item) {
            var customElements = item.customElements;
            var chgp = "";
            var dpName = "";
            var hghlTxt = "";
            var sym = "";
            if (customElements.length > 0) {
                chgp = customElements[0].chgP;
                dpName = customElements[0].dpName;
                hghlTxt = customElements[0].hghlTxt;
                sym = customElements[0].sym;
            }
            var liveNewsContent = new LiveNewsContentEntity(item.category, item.desc, item.timeText, chgp, dpName, hghlTxt, sym);
            entity.push(liveNewsContent);
        });
        return entity;
    };
    return LiveNewsDataMapper;
}());
export { LiveNewsDataMapper };
